export default __webpack_public_path__ + "static/media/Dickangel.5bca2efb.PNG";